import { Progress } from '@base-ui/react/progress'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ProgressTrackProps extends PartProps<Progress.Track.Props> {
  className?: string
}

function ProgressTrack({ className, children, ...props }: ProgressTrackProps) {
  return (
    <Progress.Track
      className={twMerge(
        'bg-element-hover corner-smooth col-span-full h-1 overflow-hidden rounded shadow-[inset_0_0_0_1px_var(--border)]',
        className,
      )}
      {...props}
    >
      {children}
    </Progress.Track>
  )
}

export { ProgressTrack }
